export default __webpack_public_path__ + "static/media/Fishing.485cba6f.gif";